module.exports = __webpack_public_path__ + "components/flag/static/square/rw-11cbd19083e31d0684277ad244060ff6.svg";